import styled from "styled-components";

export const ClientProductContainer = styled.div`
  display: flex;
  gap: 12px;
`;
